module.exports = __webpack_public_path__ + "img/2586d470cff7498b8127a827162ffbab.219eff85.png";